var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181616",
    d: "M64 0C28.7 0 0 28.7 0 64c0 28.3 18.4 52.3 43.9 60.8 3.2.6 4.4-1.4 4.4-3.1 0-1.5-.1-5.5-.1-10.8-17.8 3.9-21.5-8.6-21.5-8.6-2.9-7.3-7-9.3-7-9.3-5.7-3.9.4-3.8.4-3.8 6.3.5 9.7 6.5 9.7 6.5 5.6 9.6 14.7 6.8 18.3 5.2.6-4 2.2-6.8 4-8.4-14.2-1.6-29.1-7.1-29.1-31.6 0-7 2.5-12.7 6.5-17.2-.7-1.6-2.8-8 .6-16.7 0 0 5.3-1.7 17.5 6.6 5.1-1.4 10.6-2 16.1-2 5.5 0 11 .7 16.1 2 12.2-8.3 17.5-6.6 17.5-6.6 3.4 8.7 1.3 15.1.6 16.7 4 4.4 6.5 10.2 6.5 17.2 0 24.6-14.9 30-29.1 31.6 2.3 2 4.3 6 4.3 12.1 0 8.7-.1 15.7-.1 17.8 0 1.7 1.2 3.8 4.4 3.1C109.6 116.3 128 92.3 128 64 128 28.7 99.3 0 64 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.d80e26cecf5b1b26871159747c1993b5.svg";
export { ForwardRef as ReactComponent };